import { render, staticRenderFns } from "./HouseGlance.vue?vue&type=template&id=3bcbf600&scoped=true&"
import script from "./HouseGlance.vue?vue&type=script&lang=js&"
export * from "./HouseGlance.vue?vue&type=script&lang=js&"
import style0 from "./HouseGlance.vue?vue&type=style&index=0&id=3bcbf600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbf600",
  null
  
)

export default component.exports